import { useQuery } from '@tanstack/react-query';
import { getFriends } from '../friendsService';
import { UseQueryResult } from '@tanstack/react-query/build/modern';
import { Friend } from '@/services/friends/friendsServicesTypes';

interface useGetFriendsResult {
  data: Friend[];
}
const useGetFriends = (): UseQueryResult<useGetFriendsResult, Error> => {
  return useQuery<useGetFriendsResult, Error>({
    queryKey: ['friends'],
    queryFn: getFriends,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
  });
};

export default useGetFriends;
